export default __webpack_public_path__ + "static/media/landing-pitching-views.2a9c7584.png";